import { memo } from "react";

const ActionCopy = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.80001 5.19995H13.2C14.2792 5.19995 14.8 6.16626 14.8 6.87995V13.12C14.8 13.8336 14.2792 14.8 13.2 14.8H6.80001C5.72079 14.8 5.20001 13.8336 5.20001 13.12V6.87995C5.20001 6.16627 5.72079 5.19995 6.80001 5.19995ZM6.80001 6.39995H13.2C13.4209 6.39995 13.6 6.61486 13.6 6.87995V13.12C13.6 13.385 13.4209 13.6 13.2 13.6H6.80001C6.5791 13.6 6.40001 13.385 6.40001 13.12V6.87995C6.40001 6.61486 6.5791 6.39995 6.80001 6.39995Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.20001 1.19995H2.80001C1.72079 1.19995 1.20001 2.16626 1.20001 2.87995V9.11995C1.20001 9.83364 1.72079 10.8 2.80001 10.8H6.40001V9.59995H2.80001C2.5791 9.59995 2.40001 9.38505 2.40001 9.11995V2.87995C2.40001 2.61485 2.5791 2.39995 2.80001 2.39995H9.20001C9.42093 2.39995 9.60001 2.61485 9.60001 2.87995V6.39995H10.8V2.87995C10.8 2.16626 10.2792 1.19995 9.20001 1.19995Z"
      fill="currentColor"
    />
  </svg>
);

export default memo(ActionCopy);
